// extracted by mini-css-extract-plugin
export default {"Divider":"Divider_Divider__CKHPR","Vertical":"Divider_Vertical__mmLrF","Horizontal":"Divider_Horizontal__6LbTQ","Grey":"Divider_Grey__bpX+k","Darkgrey":"Divider_Darkgrey__hJiiR"};